import { gql } from 'graphql-request'

export const VERIFY_WRITER = gql`
  mutation Mutation($verifyWriter: WriterVerifyInput!) {
    verifyWriter(verifyWriter: $verifyWriter) {
      id
    }
  }
`
